var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"d-inline-block h3 py-2 text-dark",attrs:{"to":_vm.to}},[_c('i',{staticClass:"fas fa-chevron-left",attrs:{"aria-hidden":"true"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }